import { connect } from 'react-redux';
import React, { Component } from 'react';
import { renderKBDateInput, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

import { bindActionCreators } from 'redux';
import * as valid from 'utils/validate';
import { api,
apiUtils } from 'app/services';
import { KBFormError,
KBButton,
KBPopover } from
'components';
import * as selectors from 'app/selectors';
import { leaveEnterOptionActions, apiCallFailure } from 'app/actions';
import OrganizationOptionsRow from './OrganizationOptionsRow';
import _ from 'lodash';
import dayjs from 'utils/dayjs';
import { KBNoData } from 'components';
import PropTypes from 'prop-types';

var OrganizationOptionsCheckForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.updateOrganizationOptions = this.updateOrganizationOptions.bind(this);this.callUpdateOrgOptApi = this.callUpdateOrgOptApi.bind(this);this.updateOptions = this.updateOptions.bind(this);}getInitialState()
  {
    return {
      options: this.props.leaveOrEnterOptions.filter(option => {
        return option.cate == this.props.type;
      }),
      execute_at: new Date() };

  }updateOrganizationOptions(

  e) {
    const { org, apiCallFailureActions } = this.props;
    const { options } = this.state;

    if (options.length === 0) {
      return apiCallFailureActions({
        status: 'error',
        message: '请先在空间设置中添加待办事项！' });

    }

    let checkedOptions =
    options &&
    options.filter(op => {
      return op.checked;
    }) ||
    [];
    if (checkedOptions.length > 0) {
      this.callUpdateOrgOptApi(org.id, checkedOptions);
      KBPopover.close();
    } else {
      return apiCallFailureActions({
        status: 'error',
        message: '请至少勾选一个待办事项' });

    }
  }callUpdateOrgOptApi(

  org_id, opts) {
    const {
      fields: { execute_at },
      updateLeaveEnterOptionActions } =
    this.props;

    api.
    updateOrganizationOptions(org_id, opts[0].id, {
      execute_at: dayjs(execute_at.value || new Date()).format(
      'YYYY-MM-DD HH:mm:ss') }).


    then(
    json => {
      opts.splice(0, 1);
      updateLeaveEnterOptionActions.success(json);
      opts.length && this.callUpdateOrgOptApi(org_id, opts);
    },
    error => {
      updateLeaveEnterOptionActions.failure(error);
    });

  }updateOptions(

  optionId, value) {
    let { options } = this.state;
    options.map(op => {
      if (op.id == optionId) {
        op.checked = value;
      }
      return op;
    });
    this.setState({
      options });

  }render()

  {
    const {
      fields: { execute_at },
      submitting,
      handleSubmit,
      location_id,
      org,
      type } =
    this.props;
    var leaveOrEnterOptions = this.props.leaveOrEnterOptions;

    return (
      <form onSubmit={handleSubmit(this.updateOrganizationOptions)}>
        <header className="kb-form-header">
          <h2 className="header-title">
            {type == 'enter' ? '入驻待办事项' : '退租待办事项'}
          </h2>
          <i
          className="iconfont header-close icon-cancel"
          onClick={KBPopover.close} />

        </header>
        <KBFormError error={this.props.error} />
        <div className="kb-form-container-m">
          {type == 'enter' ?
          <div className="kb-row">
              <Field name="execute_at" component={renderKBDateInput}
            type="date"
            title="入驻日期"
            className="kb-form-group kb-div-c18 kb-form-alone"
            />

            </div> :
          null}
          <fieldset className="fieldset">
            <ul>
              {leaveOrEnterOptions.length > 0 ?
              leaveOrEnterOptions.map((option, index) => {
                return (
                  <OrganizationOptionsRow
                  key={index}
                  option={option}
                  location_id={location_id}
                  org={org}
                  updateOptions={this.updateOptions} />);


              }) :

              <div className="box-content">
                  <KBNoData className="m-updown" tipMessage="暂无待办事项" />
                </div>}

            </ul>
          </fieldset>
          <div className="kb-row fixed-form-btn">
            <span className="cancel-btn" onClick={KBPopover.close}>
              取消
            </span>
            <KBButton className="certain-btn" submitting={submitting}>
              确定
            </KBButton>
          </div>
        </div>
      </form>);

  }};


OrganizationOptionsCheckForm.propTypes = {
  location_id: PropTypes.number.isRequired,
  org: PropTypes.object.isRequired,
  type: PropTypes.string.isRequired };


function mapStateToProps(state, props) {
  const { org, type } = props;
  let leaveOrEnterOptions = selectors.getOrgOptionsOfOrgId(state, org.id);

  leaveOrEnterOptions = _.cloneDeep(leaveOrEnterOptions).filter(option => {
    return option.cate == type && !option.checked;
  });
  return {
    leaveOrEnterOptions };

}

function mapDispatchToProps(dispatch) {
  return {
    updateLeaveEnterOptionActions: bindActionCreators(
    leaveEnterOptionActions.update,
    dispatch),

    apiCallFailureActions: bindActionCreators(apiCallFailure, dispatch) };

}

const validate = values => {
  const errors = {};

  return errors;
};

const formConfig = {
  form: 'OrganizationOptionsCheckForm',
  validate: validate,
  touchOnBlur: false };


const LEGACY_FORM_FIELDS = [
  "execute_at"
];


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('OrganizationOptionsCheckForm', LEGACY_FORM_FIELDS)(OrganizationOptionsCheckForm)));
